import React from 'react';
import ServiceCardV2 from './ServiceCardV2';

const HEADINGS = {
  en: { eyebrow: 'RELATED', title: 'Related services' },
  es: { eyebrow: 'RELACIONADOS', title: 'Servicios relacionados' },
};

const RelatedServicesV2 = ({ services, lang = 'en' }) => {
  if (!services || services.length === 0) return null;
  const t = HEADINGS[lang] || HEADINGS.en;
  return (
    <section className="iv2-related-services" data-testid="iv2-related-services">
      <div className="iv2-container">
        <div className="iv2-related-services-head">
          <p className="iv2-section-eyebrow">{t.eyebrow}</p>
          <h2 className="iv2-related-services-title">{t.title}</h2>
        </div>
        <div className="iv2-related-services-grid">
          {services.map((svc) => (
            <ServiceCardV2 key={svc.id} service={svc} lang={lang} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServicesV2;
